type UploadFileResponse = {
  url: string;
  location: string;
};

type ExtractMetadataResponse = {
  creationDate: string | null;
};

export const useUploadToStorage = () => {
  const extractMetadata = async (file: File): Promise<ExtractMetadataResponse> => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('last_modified_ms', file.lastModified.toString());

    const response = await fetch(`${import.meta.env.VITE_API_URL}/files/extract-metadata`, {
      method: 'POST',
      body: formData,
      credentials: 'include',
    });

    if (!response.ok) {
      return { creationDate: null };
    }

    return response.json();
  };

  const uploadToStorage = async (file: File, clientId?: string): Promise<UploadFileResponse> => {
    const preSignedEndpoint = clientId
      ? `${import.meta.env.VITE_API_URL}/clients/${clientId}/pre-signed-upload-url`
      : `${import.meta.env.VITE_API_URL}/pre-signed-upload-url`;
    const response = await fetch(preSignedEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ fileName: file.name }),
      credentials: 'include',
    });

    if (!response.ok) throw new Error('Failed to get pre-signed URL');

    const responseBody = await response.json();
    const uploadResponse = await fetch(responseBody.url, {
      method: 'PUT',
      body: file,
      headers: { 'Content-Type': file.type },
    });

    if (!uploadResponse.ok)
      throw new Error(
        `Failed to upload file. Status: ${uploadResponse.status} ${uploadResponse.body}`,
      );

    return responseBody;
  };

  return { uploadToStorage, extractMetadata };
};
